<template>
    <UPopover mode="hover" :popper="{ arrow: true, placement: 'auto-end' }"
        :ui="{ background: 'bg-gray-900', ring: 'ring-1 ring-gray-800' }">
        <div class="flex items-center mt-1.5">
            <Icon name="material-symbols:info-outline" class="text-gray-400 text-md" />
        </div>
        <template #panel>
            <div class="p-2 text-sm">
                <span>{{ text }}</span>
            </div>
        </template>
        <!-- </div> -->
    </UPopover>
</template>

<script lang="ts" setup>
defineProps<{
    text: string
}>()
</script>